import React, { useState } from 'react';
import NewsTab from './NewsTab';
import EmailQueriesTab from './EmailQueriesTab';
import EmailTemplatesTab from './EmailTemplatesTab';

const CMS = () => {
  const [activeTab, setActiveTab] = useState('news');

  const tabs = [
    { id: 'news', label: 'News', icon: '📰' },
    { id: 'email-queries', label: 'Email Queries', icon: '📧' },
    { id: 'email-templates', label: 'Email & notifications', icon: '✉️' }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">CMS</h1>
          <p className="text-sm text-gray-500 mt-1">Manage website content, email queries, and transactional email templates</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="bg-white rounded-xl border border-gray-200">
        <div className="border-b border-gray-200">
          <nav className="flex space-x-8 px-6" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  py-4 px-1 border-b-2 font-medium text-sm transition-colors
                  ${
                    activeTab === tab.id
                      ? 'border-emerald-400 text-emerald-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                `}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="p-6">
          {activeTab === 'news' && <NewsTab />}
          {activeTab === 'email-queries' && <EmailQueriesTab />}
          {activeTab === 'email-templates' && <EmailTemplatesTab />}
        </div>
      </div>
    </div>
  );
};

export default CMS;


